import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NavbarComponent } from './navbar/navbar.component';
import { AuthNavbarComponent } from './auth-navbar/auth-navbar.component';
import { FooterComponent } from './footer/footer.component';
import { SideMenuComponent } from './sidemenu/sidemenu.component';
import { UploadPluginComponent } from './upload/upload.component';
import { ModalUploadPluginComponent } from './upload/modal-upload/modal-upload.component';
import { UploadModule } from './upload/upload.module';
import { SpinnerModule } from './spinner/spinner.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UploadModule,
    SpinnerModule
  ],
  declarations: [
    NavbarComponent,
    AuthNavbarComponent,
    FooterComponent,
    SideMenuComponent
  ],
  exports: [
    NavbarComponent,
    AuthNavbarComponent,
    FooterComponent,
    SideMenuComponent,
    UploadModule,
    SpinnerModule
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts